import { FC } from 'react';
import TableNoResults from '@/components/table/table-no-results';
import { RetailerTabType } from '@/routes/inventory/types';
import { SessionType } from '@/routes/sessions/redux/types';
import * as Tabs from './index';

interface ITabView {
	retailerId?: string;
	type: RetailerTabType | SessionType;
}

const TabView: FC<ITabView> = ({ retailerId, type }) => {
	const TAB_TYPES: Record<string, any> = {
		[RetailerTabType.globalCategories]: Tabs.GlobalCategories,
		[RetailerTabType.itemCategories]: Tabs.ItemCategories,
		[RetailerTabType.items]: Tabs.RetailerItems
	};

	if (!type || !Object.keys(TAB_TYPES).includes(type)) return <TableNoResults />;

	const Component = TAB_TYPES[type];

	return <Component retailerId={retailerId} />;
};

export default TabView;
